import { Box, Container, createStyles, Grid, List, Text, Title, useMantineTheme, ScrollArea } from '@mantine/core';
import { useElementSize, useMediaQuery } from '@mantine/hooks';

const useStyle = createStyles((theme) => ({
  root: {
    textAlign: 'left',
    paddingLeft: '5px',
    paddingRight: '1rem',
  },
}));

const SectionTitle = ({ children }: { children: React.ReactNode }) => (
  <Title order={6} align='left' pt='10px' fw={500} fz='16px' color='black'>
    {children}
  </Title>
);

const PrivacyPolicy = () => {
  const { classes } = useStyle();
  const mantinetheme = useMantineTheme();
  const mobile = useMediaQuery(`(max-width: ${mantinetheme.breakpoints.sm})`);
  const { ref, width, height } = useElementSize();

  return (
    <>
      <Container mt='-20px'>
        <div ref={ref}>
          <Grid m={0} pb={5}>
            <Grid.Col pl={0} mt={8} span={2} ta='left'>
              <Text fz='16px' fw={500} color='black'>
                PRIVACY POLICY
              </Text>
            </Grid.Col>
          </Grid>
        </div>

        <ScrollArea.Autosize type='never' mah={window.innerHeight - (height + 90)}>
          <Box pt='30px' pl='10px'>
            <Title align='left' fz={mobile ? '16px' : '18px'} fw={500} color='black'>
              {/* {moment(new Date()).format('DD MMM, YYYY')} */}
              Last update on 15 June, 2023
              {/* Effective Date: June 15, 2023 */}
            </Title>
            <Text align='left' pt='20px' fw={450} fz={mobile ? '11px' : '13px'} color='black'>
              Thank you for using Clamor To Go (the "Service"). This Privacy Policy explains how we collect, use, and
              protect your personal information when you use our Service.
            </Text>
            <SectionTitle>Information We Collect:</SectionTitle>

            <Text align='left' fw={450} pt='10px' fz={mobile ? '11px' : '13px'} color='black'>
              When you use our Service, we may collect the following types of personal information:
            </Text>
            <List fw={450} classNames={classes} fz={mobile ? '11px' : '13px'} pt='20px'>
              <List.Item>Name</List.Item>
              <List.Item>Email address</List.Item>
              <List.Item>Phone number</List.Item>
            </List>

            <Text align='left' fw={450} pt='10px' fz={mobile ? '11px' : '13px'} color='black'>
              We only collect personal information that you provide to us through the order checkout form, which is
              necessary for processing orders and verifying user accounts.
            </Text>

            <SectionTitle>Use of Your Personal Information:</SectionTitle>

            <Text align='left' fw={450} pt='10px' fz={mobile ? '11px' : '13px'} color='black'>
              Users provide their email address during account registration and must verify their email before receiving
              communications We use your email address to send transactional communications such as account
              verification, order confirmations, and service notifications.
            </Text>

            <SectionTitle>We use your personal information for the following purposes:</SectionTitle>
            <List fw={450} classNames={classes} fz={mobile ? '11px' : '13px'} pt='20px'>
              <List.Item>Processing orders and payments</List.Item>
              <List.Item>Verifying your account via OTP</List.Item>
              <List.Item>Communicating order tracking information with you</List.Item>
              <List.Item>Providing support to you if you have questions or concerns about your recent order</List.Item>
              <List.Item>Complying with legal obligations and enforcing our agreements</List.Item>
            </List>

            <Text fw={450} align='left' pt='10px' fz={mobile ? '11px' : '13px'} color='black'>
              We will not sell your personal information to third parties.
            </Text>
            <SectionTitle>Retention of Your Personal Information:</SectionTitle>
            <Text fw={450} align='left' pt='10px' fz={mobile ? '11px' : '13px'} color='black'>
              We will retain your personal information for as long as necessary to fulfill the purposes for which we
              collected it, including to comply with legal obligations, resolve disputes, and enforce our agreements.
            </Text>
            <SectionTitle>Your Data Privacy Rights:</SectionTitle>
            <SectionTitle>
              If you are a California resident, you have the following data privacy rights under the California Consumer
              Privacy Act (CCPA):
            </SectionTitle>
            <List fw={450} classNames={classes} fz={mobile ? '11px' : '13px'} pt='20px'>
              <List.Item>Right to know what personal information we have collected about you.</List.Item>
              <List.Item>Right to request deletion of your personal information.</List.Item>
              <List.Item>Right to opt-out of the sale of your personal information, if applicable.</List.Item>
            </List>

            <Text fw={450} align='left' pt='10px' fz={mobile ? '11px' : '13px'} color='black'>
              To exercise your rights under the CCPA, please email us at
              <a style={{ textDecoration: 'none', color: 'black' }} href='mailto:info@clamortogo.com'>
                {' '}
                info@clamortogo.com{' '}
              </a>
              We will respond to your request within 45 days.
            </Text>

            <SectionTitle>Data Security:</SectionTitle>
            <Text fw={450} align='left' pt='10px' fz={mobile ? '11px' : '13px'} color='black'>
              We take reasonable measures to protect your personal information from unauthorized access, disclosure,
              alteration, or destruction. We use industry-standard security practices, including encryption and access
              controls, to safeguard your personal information.
            </Text>
            <SectionTitle>Changes to Our Privacy Policy:</SectionTitle>
            <Text fw={450} align='left' pt='10px' fz={mobile ? '11px' : '13px'} color='black'>
              We reserve the right to modify this Privacy Policy at any time. If we make material changes to this
              Privacy Policy, we will notify you by email or by posting a notice on our website.
            </Text>

            <SectionTitle>Contact Us:</SectionTitle>
            <Text fw={450} align='left' pt='10px' pb={20} fz={mobile ? '11px' : '13px'} color='black'>
              If you have any questions or concerns about this Privacy Policy, please contact us at &nbsp;
              <a style={{ textDecoration: 'none', color: 'black' }} href='mailto:info@clamortogo.com'>
                info@clamortogo.com.
              </a>
            </Text>
          </Box>
        </ScrollArea.Autosize>
      </Container>
    </>
  );
};

export default PrivacyPolicy;
